import React from "react";
import Carousel from 'react-bootstrap/Carousel'

const Slideshow = ({ content }) => {
    return (
        <Carousel>
            {content.map((slide) => (
                <Carousel.Item key={slide.id}>
                    <img 
                        className="d-block w-100"
                        src={slide.slideImage.file.url} 
                        alt={slide.slideImage.description} 
                    />
                    <Carousel.Caption>
                        {slide.slideLabel && <h3>{slide.slideLabel}</h3>}
                        {slide.slideDescription && <p>{slide.slideDescription.slideDescription}</p>}
                    </Carousel.Caption>
                </Carousel.Item>
            ))}
        </Carousel>
    )
}

export default Slideshow;
